module.exports = __webpack_public_path__ + "img/icon-delete.0caaaece.svg";